// src/views/Welcome.jsx
import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

export default function Welcome() {
  const { user } = useAuth0();

  return (
    <div className="text-center mt-5">
      <h1 className="mb-3">
        ¡Bienvenido{user ? `, ${user.given_name || user.name}` : ""}!
      </h1>
      <p className="mb-4">
        Has iniciado sesión correctamente en <strong>Kovedo CloudSuite</strong>.
      </p>
      <div>
        <a href="/profile" className="btn btn-primary mr-2">
          Ir a Perfil
        </a>
        <a href="/external-api" className="btn btn-secondary">
          Ir a Recursos Protegidos
        </a>
      </div>
    </div>
  );
}
